import React from "react";
import ExcelDownloader from "../../common/ExcelDownloader/ExcelDownloader";
import { getSimpleFormattedDate } from "../../../utils/utils";

const combineChildrenHeaders = (column) => {
  const { children, label: parentLabel } = column || {};
  return children.map((child) => {
    const { id, label, type } = child;
    return {
      key: id,
      label: `${label} - ${parentLabel}`,
      type: type || "string",
    };
  });
};

const generateHeaders = (columns) => {
  return columns.flatMap((column) => {
    if (column?.children) {
      return combineChildrenHeaders(column);
    } else {
      const { id, label, type } = column;
      return { key: id, label: label, type: type || "string" };
    }
  });
};

const CreditRatingExport = ({ columns, datas, disabled = true } = {}) => {
  const headers = generateHeaders(columns);

  const tableData = datas.map((data) => {
    const row = {};
    headers.forEach((header) => {
      const { key } = header;
      row[key] = data[key];
    });
    return row;
  });
  return (
    <ExcelDownloader
      sheets={[
        {
          name: "Credit_Rating",
          header: headers,
          data: tableData,
          showHeader: true,
        },
      ]}
      disabled={disabled}
      fileName={`CreditRatingData_${getSimpleFormattedDate()}.xlsx`}
    />
  );
};

export default CreditRatingExport;
